import Reveal from '@/components/base/Reveal';
import { heroKeywords, heroStats, siteBrand } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden border-b border-background-200/70 bg-background-50">
      <div className="pointer-events-none absolute -left-32 -top-32 h-80 w-80 rounded-full bg-primary-100/60 blur-3xl" />
      <div className="pointer-events-none absolute -right-24 top-24 h-72 w-72 rounded-full bg-accent-100/70 blur-3xl" />

      <div className="relative mx-auto grid w-full max-w-[1280px] grid-cols-1 items-center gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-7">
          <Reveal>
            <div className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3.5 py-1.5 text-xs font-medium text-primary-700 md:text-sm">
              <span className="td-live-dot h-2 w-2 rounded-full bg-primary-500" />
              {siteBrand.name} · 主播与网红达人专题合集
            </div>
          </Reveal>

          <Reveal delay={80}>
            <h1 className="mt-6 font-heading text-3xl font-bold leading-[1.25] tracking-tight text-foreground-950 md:text-5xl lg:text-[56px] lg:leading-[1.15]">
              网红女神小姐姐齐聚
              <br />
              精彩内容<span className="text-primary-600">一网打尽</span>
            </h1>
          </Reveal>

          <Reveal delay={140}>
            <p className="mt-6 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              糖豆视频汇聚人气主播与网红达人，高颜值小姐姐、女神级主播每日开播，直播互动氛围火热。
              关注你喜欢的主播，随时掌握开播动态，精彩短视频与直播内容同步更新，让你一次看个够。
            </p>
          </Reveal>

          <Reveal delay={200}>
            <div className="mt-6 flex flex-wrap gap-2">
              {heroKeywords.map((word) => (
                <a
                  key={word}
                  href="#live"
                  className="cursor-pointer rounded-full bg-secondary-100 px-3.5 py-1.5 text-xs font-medium text-secondary-900 transition-colors hover:bg-secondary-200 md:text-sm"
                >
                  #{word}
                </a>
              ))}
            </div>
          </Reveal>

          <Reveal delay={260}>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#live"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:text-base"
              >
                <i className="ri-live-line" />
                立即进入直播间互动
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600 md:text-base"
              >
                <i className="ri-user-add-line" />
                关注喜欢的主播
              </a>
            </div>
          </Reveal>

          <Reveal delay={320}>
            <dl className="mt-10 grid grid-cols-3 gap-4 border-t border-background-200 pt-6 md:max-w-xl">
              {heroStats.map((stat) => (
                <div key={stat.label}>
                  <dt className="font-heading text-xl font-bold text-foreground-950 md:text-3xl">{stat.value}</dt>
                  <dd className="mt-1 text-xs text-foreground-500 md:text-sm">{stat.label}</dd>
                </div>
              ))}
            </dl>
          </Reveal>
        </div>

        <div className="lg:col-span-5">
          <Reveal delay={200}>
            <div className="relative mx-auto w-full max-w-md lg:max-w-none">
              <div className="relative aspect-[4/5] w-full overflow-hidden rounded-2xl border border-background-200 bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylized%20artistic%20editorial%20collage%20of%20several%20elegant%20young%20asian%20women%20performers%20on%20warm%20coral%20and%20amber%20gradient%20background%2C%20soft%20glowing%20light%2C%20abstract%20flowing%20shapes%2C%20high-end%20magazine%20cover%20aesthetic%2C%20subtle%20film%20grain%2C%20harmonious%20warm%20palette&width=900&height=1100&seq=td-hero-01&orientation=portrait"
                  alt="糖豆视频人气主播与网红达人专题合集"
                  title="糖豆视频 主播 网红 女神 直播合集"
                  className="h-full w-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/55 via-foreground-950/5 to-transparent" />

                <div className="absolute left-4 top-4 flex items-center gap-2 rounded-full bg-foreground-950/60 px-3 py-1.5 text-xs font-medium text-background-50 backdrop-blur-sm">
                  <span className="td-live-dot h-1.5 w-1.5 rounded-full bg-primary-400" />
                  8,600+ 位主播正在开播
                </div>

                <div className="absolute bottom-4 left-4 right-4 rounded-xl border border-background-50/20 bg-background-950/55 p-4 backdrop-blur-md">
                  <div className="flex items-center justify-between gap-3">
                    <div>
                      <p className="font-heading text-base font-bold text-background-50">专题合集 · 每日更新</p>
                      <p className="mt-1 text-xs text-background-100/80">深夜女声 / 国风夜宴 / 颜值舞蹈</p>
                    </div>
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50">
                      <i className="ri-arrow-right-line text-lg" />
                    </span>
                  </div>
                </div>
              </div>

              <div className="absolute -left-4 top-1/3 hidden rounded-xl border border-background-200 bg-background-50 p-3 shadow-none md:block">
                <div className="flex items-center gap-2">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className="ri-fire-line text-lg" />
                  </span>
                  <div>
                    <p className="font-heading text-sm font-bold text-foreground-950">热辣互动</p>
                    <p className="text-[11px] text-foreground-500">弹幕密度实时领先</p>
                  </div>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}